// Lấy 30 ảnh trong public/images/1.webp..30.webp
const ALL_IMAGES: string[] = Array.from({ length: 30 }).map(
  (_, i) => `/images/${i + 1}.webp`
);

// Hàm shuffle để random thứ tự
function shuffle<T>(arr: T[]): T[] {
  return [...arr]
    .map((a) => ({ sort: Math.random(), value: a }))
    .sort((a, b) => a.sort - b.sort)
    .map((a) => a.value);
}

// Random chọn 20 ảnh từ 30 ảnh có sẵn
export function getRandomCardImages(): string[] {
  const shuffled = shuffle(ALL_IMAGES);
  return shuffled.slice(0, 20);
}

// Dùng hàm này mỗi khi chơi game để có random khác nhau
export const CARD_IMAGES: string[] = getRandomCardImages();

export function preloadImages() {
  // Preload card back image
  const backImg = new Image();
  backImg.src = '/images/0.webp';
  
  // Preload game card images
  CARD_IMAGES.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}